var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Application',{attrs:{"uuid":_vm.uuid},on:{"success":_vm.success}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }